import { makeStyles } from '@mui/styles';

const NewProjectDialogStyle = makeStyles(() => ({
    mainDilogBoxSection: {
        '& .MuiPaper-root': {
            borderRadius: '10px !important',
            minWidth: '65%',
        },
    },
    inviteUserButton: {
        textAlign: 'right',
        marginBottom: '20px',
        '& button': {
            border: '1px solid #787878',
            textTransform: 'capitalize',
        },
    },
    dilogBoxSection: {
        borderBottom: '1px solid #CECECE',
        padding: '10px 32px !important',
        fontSize: '20px !important',
        fontWeight: '600 !important',
    },
    dilogBoxSectionText: {
        fontSize: '16px !important',
        color: '#050505 !important',
        padding: '16px 0px',
    },
    dilogBoxSectionSelectBox: {
        margin: '30px 0px',
        '& .MuiSelect-outlined': {
            padding: '11px',
        },
        '& .MuiOutlinedInput-root': {
            border: '1px solid #787878',
            width: '100%',
        },
        '& fieldset': {
            border: 'none',
        },
    },
    dilogBoxSectionFooter: {
        padding: '10px 32px !important',
        borderTop: '1px solid #CECECE',
        '& button': {
            textTransform: 'capitalize',
            boxShadow: 'none',
            fontSize: '16px',
            padding: '7px 32px',
        },
    },
    outlineButton: {
        marginLeft: '15px',
        '& button': {
            fontSize: '12px',
            color: '#787878',
            border: '1px solid #787878',
            borderRadius: '4px',
            backgroundColor: 'transparent',
            padding: '3px 11px',
            cursor: 'pointer',
            textTransform: 'unset',
            fontFamily: 'Inter-Medium',
            '& svg': {
                color: '#787878',
                fontSize: '15px',
                verticalAlign: 'sub',
                marginRight: '4px',
            },
        },
    },
    filledButton: {
        marginLeft: '15px',
        '& button': {
            fontSize: '12px',
            color: '#fff',
            border: '1px solid #007DFF',
            borderRadius: '4px',
            backgroundColor: '#007DFF',
            boxShadow: `0px 2.85714px 4.7619px -1.90476px rgba(0, 0, 0, 0.2), 0px 1.90476px 2.85714px rgba(0, 0, 0, 0.14),
             0px 0.952381px 4.7619px rgba(0, 0, 0, 0.12)`,
            padding: '3px 11px',
            cursor: 'pointer',
            textTransform: 'unset',
            fontFamily: 'Inter-Medium',
            '&:hover': {
                backgroundColor: '#007DFF !important',
            },
            '& svg': {
                color: '#fff',
                fontSize: '15px',
                verticalAlign: 'sub',
                marginRight: '5px',
            },
        },
    },
    labelSideText: {
        color: '#353535',
        marginRight: '4px !important',
    },
    mainTextLabel: {
        fontSize: '18px !important',
        fontWeight: '600 !important',
        color: '#353535',
        padding: '6px 0px',
    },
    dialogBody: {
        backgroundColor: '#F9F9F9',
        padding: '0px !important',
        '& input': {
            padding: '6px',
            height: '22px',
            fontSize: '14px',
            borderRadius: '5px',
            color: '#605F5F',
            border: '1px solid #fdfdfd',
            backgroundColor: '#ffffff',
        },
    },
    sectionBody: {
        padding: '32px !important',
        '& .MuiFormControl-root': {
            margin: '0px !important',
            minWidth: '100%',
        },
        '& .MuiSelect-select': {
            padding: '6px',
            fontSize: '14px',
            height: '22px !important',
            borderRadius: '5px',
            color: '#605F5F',
            border: '1px solid #fdfdfd',
            backgroundColor: '#ffffff',
            alignItems: 'center',
            display: 'flex',
        },
    },
    sectionTwoBody: {
        padding: '32px !important',
        '& .MuiSelect-select': {
            padding: '6px',
            fontSize: '14px',
            height: '22px !important',
            borderRadius: '5px',
            color: '#605F5F',
            border: '1px solid #fdfdfd',
            backgroundColor: '#ffffff',
            alignItems: 'center',
            display: 'flex',
        },
    },
    labelText: {
        marginBottom: '6px !important',
        color: '#353535',
    },
    labelTextFirst: {
        marginBottom: '6px !important',
        marginLeft: '112px !important',
        color: '#353535',
    },
    smText: {
        width: '41px !important',
        marginLeft: '10px !important',
    },
    sideTextInput: {
        alignItems: 'center',
        display: 'flex',
    },
}));

export default NewProjectDialogStyle;
